/*eslint-disable import/default */
import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from './components/App/App';
import HomePage from './components/HomePage/HomePage';
import StatementsPage from './components/StatementsPage/StatementsPage';
import FaqPage from './components/FaqPage/FaqPage';
import LoginPage from './components/LoginPage/LoginPage';
import LogoutPage from './components/LogoutPage/LogoutPage';
import PageNotFoundPage from './components/PageNotFoundPage/PageNotFoundPage';
import * as serviceWorker from './serviceWorker';

import './styles/styles.css';
import {setMixPanelToken} from '@forwardfinancing/analytics-frontend-library';
import { datadogRum } from '@datadog/browser-rum';
import {
  APP_VERSION,
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  DATADOG_SITE,
  DEPLOY_ENV,
  MIXPANEL_API_TOKEN,
} from './constants/global';
setMixPanelToken(MIXPANEL_API_TOKEN());

datadogRum.init({
  applicationId: DATADOG_RUM_APPLICATION_ID(),
  clientToken: DATADOG_RUM_CLIENT_TOKEN(),
  site: DATADOG_SITE(),
  service: 'merchant_portal',
  env: DEPLOY_ENV(),
  version: APP_VERSION(),
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  enablePrivacyForActionName: true,
  defaultPrivacyLevel: 'mask-user-input',
});

const store = configureStore();

render(
  <Provider store={store}>
    <BrowserRouter>
      <App>
        <Switch>
          <Route exact path="/owner" component={HomePage}/>
          <Route exact path="/owner/statements" component={StatementsPage}/>
          <Route exact path="/owner/faq" component={FaqPage}/>
          <Route exact path="/owner/sign_in" component={LoginPage}/>
          <Route exact path="/owner/sign_out" component={LogoutPage}/>
          <Route path="*" component={PageNotFoundPage}/>
        </Switch>
      </App>
    </BrowserRouter>
  </Provider>,
  document.getElementById('app')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
